module.exports = __webpack_public_path__ + "media/public/fonts/QanelasMedium/QanelasMedium-1bf423469eb2e05e3701faf5670118d6.woff2";